import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { SwitchComponent } from '../../Utils/Index';
import ModalComponent from '../../Utils/Modal/Index';
import Form from './Form';
import useDisclosure from '../../../hooks/useDisclosure';
import { TrashIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';
import { useAppContext } from '../../../context';
import opsService from '../../../services/ops/opsService';
import { toast } from 'react-toastify';

export const TableRow = ({ item }) => {
    const [template, setTemplate] = useState({})
    const { isOpen, onClose, onOpen } = useDisclosure();
    const { isAuth } = useAppContext();
    const { isOpen: isOpenDelete, onClose: onCloseDelete, onOpen: onOpenDelete } = useDisclosure();
    const [selectedId, setSelectedId] = useState(false);

    const onToggleActive = (item, type, value) => {
        //alert(item.id);

        let data = { type: type, value: value }
        let newValue = template;
        newValue[type] = !newValue[type] ? 1 : 0;
        setTemplate({ ...newValue });


    }

    useEffect(() => {
        setTemplate(item)
    }, [item])

    const handleDeleteTracking = async () => {
        try {
            const toastId = toast.loading("Suppression en cours...")


            opsService.deleteTracking({
                id: selectedId
            }).then(
                (response) => {
                    toast.update(toastId, {
                        render: "Suppression effectuée",
                        type: "success",
                        isLoading: false,
                        autoClose: 5000,
                    });
                    setSelectedId(false)
                    onCloseDelete()
                },
                (error) => {
                    toast.update(toastId, {
                        render: "Une erreur est survenue",
                        type: "error",
                        isLoading: false,
                        autoClose: 5000,
                    });
                    setSelectedId(false)
                    onCloseDelete()
                    console.log(error)
                }
            )

        } catch (error) {
            console.error(error)
            toast.error("Une erreur est survenue")
        }
    }
    

    const openModal = (id) => {
        setSelectedId(id)
        onOpenDelete()
    }

    return (

        <>
            <ModalComponent isOpen={isOpen} onClose={onClose} title={'Détails de template tracking'}>
                <Form selectedValue={item} />
            </ModalComponent>

            <tr key={template?.id}>
                <td className="px-6 py-2 text-sm border-b border-gray-200 cursor-pointer" onClick={onOpen}>
                    {template?.id}
                </td>
                <td className="px-6 py-2 text-sm border-b border-gray-200 cursor-pointer" onClick={onOpen}>
                    {template?.details}
                </td>
                <td className="px-6 py-2 text-sm border-b border-gray-200">
                    <SwitchComponent
                        checked={Boolean(template?.isparis)}
                        disabled
                        onChange={(value) => {
                            //onToggleActive(template, 'isparis', value);
                        }}
                    />
                </td>
                <td className="px-6 py-2 text-sm border-b border-gray-200">
                    <SwitchComponent
                        checked={Boolean(template?.ismedical)}
                        onChange={(value) => {
                            // onToggleActive(template, 'ismedical', value);
                        }}
                    />
                </td>
                <td className="px-6 py-2 text-sm border-b border-gray-200">
                    <SwitchComponent
                        checked={Boolean(template.isservice)}
                        onChange={(value) => {
                            // onToggleActive(template, 'isservice', value);
                        }}
                    />
                </td>
                <td className="px-6 py-2 text-sm border-b border-gray-200">
                    <SwitchComponent
                        checked={Boolean(template.isdriver)}
                        onChange={(value) => {
                            // onToggleActive(template, 'isdriver', value);
                        }}
                    />
                </td>
                <td className="px-6 py-2 text-sm border-b border-gray-200 cursor-pointer" onClick={onOpen}>
                    {moment(template.created_at).format("DD-MM-YYYY")}{" "} <br />
                    {moment(template.created_at).format("HH:mm")}{" "}
                </td>
                <td>
                    <button
                        onClick={() => openModal(item.id)}
                        className={clsx({
                            "bg-paris": isAuth?.spaceName === "paris",
                            "bg-medical": isAuth?.spaceName === "medical",
                            "bg-service": isAuth?.spaceName === "service",
                            "bg-admin": isAuth?.spaceName === "admin",
                        }, " p-1.5 text-white  rounded-t-md text-center")}
                    >
                        <TrashIcon className="w-6 h-6" />
                    </button>
                </td>
            </tr>
            <ModalComponent isOpen={isOpenDelete} onClose={onCloseDelete} title={"Suppression de suivis"}>
                <>
                    <div className='space-y-3 mt-5'>
                        <h3 className='text-center'>Vous voulez vraiment supprimer ce suivi ?</h3>
                        <div className="flex justify-center items-center">
                            <button
                                className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-lg"
                                onClick={() => {
                                    setSelectedId(false)
                                    onCloseDelete()
                                }}
                            >
                                Non
                            </button>
                            <button
                                className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded-lg ml-2"
                                onClick={handleDeleteTracking}
                            >
                                Oui,je supprime
                            </button>
                        </div>
                    </div>
                </>
            </ModalComponent>
        </>

    );
}

